import parseOptionalQuestions from 'utils/pivot/compliance/parseOptionalQuestions'
import parseDisclosures from 'utils/pivot/compliance/parseDisclosures'
import parseDisclaimers from 'utils/pivot/compliance/parseDisclaimers'
import parseAgreements from 'utils/pivot/compliance/parseAgreements'
import parseQuestions from 'utils/pivot/compliance/parseQuestions'
import parseTerms from 'utils/pivot/compliance/parseTerms'

function parseResponse(complianceResponse): Compliance {
  const { terms, agreements, disclosures, questions, optionalQuestions, disclaimers } =
    complianceResponse

  return {
    terms: parseTerms(terms),
    agreements: parseAgreements(agreements),
    disclosures: parseDisclosures(disclosures),
    questions: parseQuestions(questions),
    optionalQuestions: parseOptionalQuestions(optionalQuestions),
    disclaimers: parseDisclaimers({ disclaimers })
  }
}

export default parseResponse
